/**
 * The icon row's four tiles (fix D / R2). Every tile is its OWN memoised leaf
 * with its own subscription, so "the game just ended" costs four tile renders
 * and not a rail render (UX spec §6a); each calls its own `model` hook and
 * spreads it into its `View` (unit convention §1).
 */
import React from 'react';

import AnalysisActionView from './AnalysisAction.View';
import LobbyActionView from './LobbyAction.View';
import NewGameActionView from './NewGameAction.View';
import ReviewActionView from './ReviewAction.View';
import TournamentActionView from './TournamentAction.View';
import {useAnalysisActionModel} from './AnalysisAction.model';
import {useLobbyActionModel} from './LobbyAction.model';
import {useNewGameActionModel} from './NewGameAction.model';
import {useReviewActionModel} from './ReviewAction.model';
import {useTournamentActionModel} from './TournamentAction.model';

export const LobbyAction = React.memo(function LobbyAction() {
  return <LobbyActionView {...useLobbyActionModel()} />;
});

export const NewGameAction = React.memo(function NewGameAction() {
  return <NewGameActionView {...useNewGameActionModel()} />;
});

export const AnalysisAction = React.memo(function AnalysisAction() {
  return <AnalysisActionView {...useAnalysisActionModel()} />;
});

export const ReviewAction = React.memo(function ReviewAction() {
  return <ReviewActionView {...useReviewActionModel()} />;
});

/** mounted INSTEAD of Review inside a tournament game (R2). */
export const TournamentAction = React.memo(function TournamentAction() {
  return <TournamentActionView {...useTournamentActionModel()} />;
});
